<template>
  <div class="landingPage wrapper">
    <ciaHeader />
    <ueTop />
    <div class="section section--project" :class="[isBannerVisible ? 'on' : 'off']">
      <div class="section__visibility"
           v-observe-visibility="bannerVisibility"
      ></div>
      <topBanner />
    </div>
    <div class="section section--project">
      <div class="section__offset"
           id="o-projekcie"></div>
      <div class="section__visibility"></div>
      <ciaDesc
        v-if="projectDescription"
        v-for="(ciaDescription, index) in projectDescription"
        :key="index"
        :descData="ciaDescription"
      />
    </div>
    <div class="section section--benefits" :class="[isBenefitsVisible ? 'on' : 'off']">
      <div class="section__offset" id="korzysci"></div>
      <div class="section__visibility"
           v-observe-visibility="benefitsVisibility"
      ></div>
      <defaultSection :header="'Korzyści'">
        <benefits />
      </defaultSection>
    </div>
    <div class="section section--offer" :class="[isOfferVisible ? 'on' : 'off']">
      <div class="section__offset" id="oferta"></div>
      <div class="section__visibility"
           v-observe-visibility="offerVisibility"></div>
      <offer />
    </div>
    <div class="section section--contact" :class="[isContactVisible ? 'on' : 'off']">
      <div class="section__offset" id="kontakt"></div>
      <div class="section__visibility"
           v-observe-visibility="contactVisibility"></div>
      <defaultSection :header="'Kontakt'">
        <contact />
      </defaultSection>
    </div>
    <downloads />
    <ciaFooter />
  </div>
</template>

<script>
import ciaHeader from './../components/LandingPage/ciaHeader.vue';
import topBanner from './../components/LandingPage/Banner.vue';
import ciaDesc from './../components/LandingPage/desc.vue';
import defaultSection from './../components/LandingPage/defaultSection.vue';
import benefits from '../components/LandingPage/Benefits.vue';
import offer from '../components/LandingPage/Offer.vue';
import downloads from '../components/LandingPage/DownloadApp.vue';
import contact from '../components/LandingPage/Contact.vue';
import ciaFooter from '../components/LandingPage/Footer.vue';
import ueTop from '../components/LandingPage/UeTop.vue';

export default {
  name: 'LandingPage',
  data: () => ({
    isBenefitsVisible: false,
    isOfferVisible: false,
    isContactVisible: false,
    isBannerVisible: false,
    projectDescription: [
      {
        image: 'about.jpg',
        header: 'O centrum',
        desc: 'Innowacyjne Centrum Archiwizacji jest kompleksową usługę archiwizacji dokumentacji, danych ' +
          'i obiektów (niezależnie od ich formatu i postaci: fizycznej lub cyfrowej). Jest to pierwsza tego ' +
          'rodzaju usługa hybrydowa w skali kraju – Archiwum 3D, umożliwia archiwizację nie tylko dokumentów, ' +
          'ale również wszelkich ciał stałych wraz ze zdalnym dostępem do nich z każdego miejsca na świecie ' +
          'i z każdego urządzenia (np. tablet, desktop, telefon)',
        align: 'left',
      },
      {
        image: 'about2.jpg',
        header: 'Nowoczesna archiwizacja',
        desc: 'Swobodny dostęp do swoich zasobów z każdego rodzaju nośnika – desktop, tablet, telefon',
        align: 'right',
      },
    ],
  }),
  components: {
    topBanner,
    ciaDesc,
    defaultSection,
    benefits,
    contact,
    downloads,
    ciaFooter,
    ciaHeader,
    offer,
    ueTop,
  },
  methods: {
    scrollToSection() {
      const currentQuery = this.$route.query;
      if (currentQuery && currentQuery.sekcja) {
        this.$scrollTo(`#${currentQuery.sekcja}`, 500);
      }
    },
    offerVisibility(isVisible) {
      this.isOfferVisible = isVisible;
    },
    benefitsVisibility(isVisible) {
      this.isBenefitsVisible = isVisible;
    },
    contactVisibility(isVisible) {
      this.isContactVisible = isVisible;
    },
    bannerVisibility(isVisible) {
      this.isBannerVisible = isVisible;
    },
  },
  mounted() {
    const currentQuery = this.$route.query;
    if (currentQuery && currentQuery.sekcja) {
      this.scrollToSection(currentQuery.sekcja);
    }
  },
  watch: {
    $route() {
      this.scrollToSection();
    },
  },
};
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Poppins:400,500,700&subset=latin-ext');
  @import "./../scss/landingpage.scss";
  .section {
    position: relative;
    z-index: 1;
    &--offer {
      background: url("./../assets/bcg-offer.jpg") 50% 0 no-repeat #fff;
      background-size: 1400px auto;
      @media (min-width: 1200px) {
        background-size: contain;
      }
    }
    &__offset {
      position: absolute;
      left: 0;
      height: 1px;
      top: -100px;
      pointer-events: none;
      @media (min-width: 550px) {
        top: -200px;
      }
    }
  }
</style>
